<template>
  <div>
    <div class="rf-cabecera">
      <span class="rf-eyebrow">Nuestros Proyectos</span>
      <h1 class="rf-titulo-serif">{{ nombre.toUpperCase() }}</h1>
      <p class="rf-tagline">No es huir, es elegir vivir mejor.</p>
    </div>

    <p v-if="error" class="rf-estado rf-estado--error">{{ error }}</p>
    <div v-else-if="!cargando && !proyectos.length" class="rf-estado">
      <p>Aún no hay proyectos en esta región.</p>
      <p style="margin-top: 18px"><a href="/landing-refugios/proyectos" class="rf-btn">← Ver otras regiones</a></p>
    </div>
    <div v-else class="rf-grilla">
      <rf-tarjeta v-for="p in proyectos" :key="p.id" :p="p" />
    </div>
  </div>
</template>

<script>
import RfTarjeta from './RfTarjeta.vue';
import { listarProyectos } from '@/services/refugiosApi';

export default {
  name: 'RfRegion',
  components: { RfTarjeta },
  props: {
    region: { type: Number, required: true },
    sitio: { type: Object, required: true },
  },
  data() {
    return { proyectos: [], cargando: true, error: '' };
  },
  computed: {
    nombre() {
      const r = this.sitio.regiones.find((x) => x.id === this.region);
      return r ? r.nombre : '';
    },
  },
  async mounted() {
    try {
      this.proyectos = await listarProyectos({ region: this.region });
    } catch (e) {
      this.error = 'No se pudieron cargar los proyectos de esta región.';
    } finally {
      this.cargando = false;
    }
  },
};
</script>
